<template>
  <section
    class="d-flex flex-row rounded-4 py-2 px-4 shadow"
    :class="isActive ? 'bg-blue-300' : 'bg-white'"
  >
    <div class="d-flex flex-column text-left text-blue-700">
      <div class="h5 mb-2">
        {{ companyName }}
      </div>
      <div class="text-muted mb-2">
        {{ bankAccount?.name }}
      </div>
      <div> {{ formatedIban }} </div>
    </div>
    <div class="d-flex ms-auto my-auto">
      <span
        class="badge badge-pill rounded-pill px-2 fs-6 fw-bold lead"
        :class="isActive ? 'bg-green-300' : 'bg-gray-300 cursor-pointer'"
        style="min-width: 120px"
        @click.stop="activateIban"
      >
        {{ isActive ? 'Principale' : 'Changer en principale' }}
      </span>
    </div>
    <div
      class="my-auto ms-2"
      :class="isActive ? 'invisible' : 'd-flex' "
    >
      <v-loader-icon
        :action="deleteIban"
      />
    </div>
  </section>
</template>

<script>
import { ui } from '@/mixins';

import LoaderIcon from '@/components/common/helpers/LoaderIcon.vue';

export default {
  name: 'AccountListIban',
  components: {
    'v-loader-icon': LoaderIcon,
  },
  mixins: [ui],
  props: {
    bankAccount: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    formatedIban() {
      if (this.bankAccount.iban) {
        const { iban } = this.bankAccount;
        const countryCode = iban.substring(0, 2);
        const numberEnding = iban.substring(iban.length - 4);
        return `${countryCode}***********************${numberEnding}`;
      }
      const { lastNumbers, numberEnding, countryCode } = this.bankAccount;
      const ibanEnding = lastNumbers || numberEnding || '';
      return `${countryCode}***********************${ibanEnding}`;
    },
    companyName() {
      return this.$store.getters['company/get'].name;
    },
    isActive() {
      return this.bankAccount.active;
    },
  },
  methods: {
    dispatchIbanAction({ goCardlessAction, paymentMethodAction }) {
      if (this.bankAccount.source === 'goCardless') {
        return this.$store.dispatch(goCardlessAction, this.bankAccount.id);
      }
      return this.$store.dispatch(paymentMethodAction, this.bankAccount.id);
    },
    deleteIban() {
      if (this.isActive) { return Promise.resolve() }

      const action = async () => {
        await this.dispatchIbanAction({
          goCardlessAction: 'payments/deleteGoCardlessBankAccount',
          paymentMethodAction: 'payments/removePaymentMethod',
        });
      };
      this.ui_accountModal({ type: 'deleteSepa', value: true, action });
      return Promise.resolve();
    },
    activateIban() {
      if (!this.isActive) {
        const action = async () => {
          await this.dispatchIbanAction({
            goCardlessAction: 'payments/activateGoCardlessBankAccount',
            paymentMethodAction: 'payments/activatePaymentMethodFromId',
          });
        };
        this.ui_accountModal({ type: 'activateSepa', value: true, action });
      }
    },
  },
};
</script>
